import Vue from 'vue'
import Router from 'vue-router'
import index from "../views/index/index"
import course from "../views/course/index"
import NewsInformation from '../views/NewsInformation/index'
import qualityControl from '../views/QualityControl/index'
import CenterProfile from '../views/CenterProfile/index'
import CourseDetails from '../views/CourseDetails/index'
import Login from '../views/Login/index'
import NewsDetails from '../views/NewsDetails/index'
import NewsDetailsTwo from '../views/NewsDetailsTwo/index'
import NewsDetailsThree from '../views/NewsDetailsThree/index'
import PersonalCenter from '../views/PersonalCenter/index.vue'
import QualityControlDetails from '../views/QualityControlDetails/index'
import Network from "@/views/Network/index.vue";
import Announcement from "@/views/Announcement/index.vue"
import Meeting from "@/views/Meeting/index.vue";
import Information from "@/views/Information/index.vue";
import codeLogin from "@/views/Login/codeLogin.vue";
import ForumCenter from "@/views/ForumCenter/index.vue";
import ForumCenterDetails from "@/views/ForumCenter/details.vue";
import Sector from '@/views/Sector/index.vue'
import Handbook from '@/views/Handbook/index.vue'
import Search from '@/views/Search/index.vue'
import Recruitment from "@/views/Recruitment/index.vue";
import Recruitment2 from "@/views/Recruitment/index2.vue";
import Recruitment3 from "@/views/Recruitment/index4.vue";
import Publish from "@/views/Publish/index.vue";
import MakeAnAppointment from "@/views/Recruitment/index3.vue";
import LiveDetail from "@/views/Meeting/details.vue";

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        // 首页
        {
          path: '/index',
          name: 'index',
          component: index,
          meta: {}
        }
      ]
    },
    {
      path: '/PersonalCenter',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta: {}
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {}
    },
    {
      path: '/codeLogin',
      name: 'codeLogin',
      component: codeLogin,
      meta: {}
    },
    {
      path: '/course',
      name: 'course',
      component: course,
      meta: {}
    },
    {
      path: '/Information',
      name: 'Information',
      component: Information,
      meta: {}
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search,
      meta: {}
    },
    {
      path: '/Recruitment',
      name: 'Recruitment',
      component: Recruitment,
      meta: {}
    },
    {
      path: '/Recruitment2',
      name: 'Recruitment2',
      component: Recruitment2,
      meta: {}
    },
    {
      path: '/Recruitment3',
      name: 'Recruitment3',
      component: Recruitment3,
      meta: {}
    },
    {
      path: '/Publish',
      name: 'Publish',
      component: Publish,
      meta: {}
    },
    {
      path: '/Meeting',
      name: 'Meeting',
      component: Meeting,
      meta: {}
    },
    {
      path: '/LiveDetail/:id',
      name: 'LiveDetail',
      component: LiveDetail,
      meta: {}
    },
    {
      path: '/Handbook',
      name: 'Handbook',
      component: Handbook,
      meta: {}
    },
    {
      path: '/NewsInformation',
      name: 'NewsInformation',
      component: NewsInformation,
      meta: {}
    },
    {
      path: '/Network',
      name: 'Network',
      component: Network,
      meta: {}
    },
    {
      path: '/Announcement',
      name: 'Announcement',
      component: Announcement,
      meta: {}
    },
    {
      path: '/qualityControl',
      name: 'qualityControl',
      component: qualityControl,
      meta: {}
    },
    {
      path: '/CenterProfile',
      name: 'CenterProfile',
      component: CenterProfile,
      meta: {}
    },
    {
      path: '/Sector',
      name: 'Sector',
      component: Sector,
      meta: {}
    },
    {
      path: '/ForumCenter',
      name: 'ForumCenter',
      component: ForumCenter,
      meta: {}
    },
    {
      path: '/ForumCenterDetails/:id',
      name: 'ForumCenterDetails',
      component: ForumCenterDetails,
      meta: {}
    },
    {
      path: '/CourseDetails/:id',
      name: 'CourseDetails',
      component: CourseDetails,
      meta: {}
    },
    {
      path: '/NewsDetails/:id',
      name: 'NewsDetails',
      component: NewsDetails,
      meta: {}
    },
    {
      path: '/NewsDetailsTwo/:id',
      name: 'NewsDetailsTwo',
      component: NewsDetailsTwo,
      meta: {}
    },
    {
      path: '/NewsDetailsThree/:id',
      name: 'NewsDetailsTwo',
      component: NewsDetailsThree,
      meta: {}
    },
    {
      path: '/QualityControlDetails/:id',
      name: 'QualityControlDetails',
      component: QualityControlDetails,
      meta: {}
    },
    {
      path: '/makeAnAppointment/:id',
      name: 'MakeAnAppointment',
      component: MakeAnAppointment,
      meta: {}
    }
  ]
})

/*进入路由之前*/
router.beforeEach((to, from, next) => {
  let loginInfo = window.localStorage.getItem('userInfo')//用户信息
  let token = window.localStorage.getItem('token')//用户token
  console.log('islogin', to.meta.isToken)
  /*判断是否需要token*/
  if (to.meta.isToken) {
    if (loginInfo == null && token == null) {
      console.log('没有token,被拦截')
      return next("/login")
    } else {
      next()
    }
  } else {
    if (to.path === '/') {
      // 重定向到首页
      return next("/index")
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js